import { createActions } from 'redux-actions';

export const actions = createActions({
  RECOMMENDED_DISTRIBUTION: {
    COMPARE: boolean => boolean,
  },
}).recommendedDistribution;
